import { type RootState } from "app";

export const selectIsToolbarVisible = (state: RootState, toolbarId: string): boolean =>
    state.toolbarVisibility[toolbarId] ?? true;
